(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('license-shop', {
            parent: 'app',
            url: '/settings/outlet/license',
            data: {
                authorities: ['ROLE_PARTNER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/partner/license/license-shop.html',
                    controller: 'LicenseShopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('license');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
